module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Gb-Ha-Id-Ja.084686bf.png";